import CryptoJS, { AES, SHA256 } from "crypto-js";
const Secret = process.env.REACT_APP_Secret || "watt-secret"




function encryption(data) {
    const isStringified = (typeof data === "string");
    let encryptedText
    if (isStringified) {
        alert(1)
        return encryptedText = AES.encrypt(data, Secret).toString();

    } else {
        alert(2)
        return encryptedText = AES.encrypt(JSON.stringify(data), Secret).toString();

    }
}

function SHA_Encryption(data) {
    return SHA256(data).toString();
}



async function decryption(data) {
    const bytes = CryptoJS.AES.decrypt(decodeURIComponent(data), Secret);
    return bytes.toString(CryptoJS.enc.Utf8);
}



export {
    encryption,
    SHA_Encryption,
    decryption
}